import React from 'react';
import { cn } from '@/lib/utils';

export interface TableActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const TableActions = React.forwardRef<HTMLDivElement, TableActionsProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('flex justify-end gap-1 whitespace-nowrap', className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

TableActions.displayName = 'TableActions';

